<template>
	<div class="daterange">
		<h6>{{title}}</h6>
		<div class="row">
			<div class="col-md-6">
				<b-form-datepicker :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" size="xs" id="datepicker1" v-model="dateStart" class="mb-0 p-0" />
			</div>
			<div class="col-md-6">
				<b-form-datepicker :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"  size="xs" id="datepicker2" v-model="dateEnd" class="mb-0 p-0" />
			</div>
		</div>
	</div>
</template>

<script>

export default{
	props:["title", "value"],
	components:{
	},
	data() 
	{
		return {
			dateStart: this.value.Start,
			dateEnd: this.value.End,
		}
	},
	watch:{
		dateStart() {
			this.$emit('input', { Start: this.dateStart, End: this.dateEnd })
		},
		dateEnd() {
			this.$emit('input', { Start: this.dateStart, End: this.dateEnd })
		},
	},
	mounted(){
	},
	methods:{
	}
}

</script>
<style>

.b-form-datepicker .btn {
    margin: 0px;
    padding: 0px 10px;
}

</style>